module.exports = __webpack_public_path__ + "static/media/eif-efront.455a10cb.png";